import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.section`
	padding: 80px 0;
	text-align: center;

	${minWidth('tablet')} {
		padding: 120px 0;
	}
`;

export const Heading = styled.h1`
	color: ${palette('blue3')};
	font-size: 28px;
	${fontWeight(FontWeights.Medium)};
	grid-column: 1 / 4;
	margin-bottom: 40px;

	${minWidth('tablet')} {
		font-size: 49.5px;
		${fontWeight(FontWeights.Regular)};
	}
`;

export const BenefitsWrapper = styled.div`
	grid-column: 1 / 4;
	margin: 0;
	margin-bottom: 40px;
	text-align: center;
`;

export const BenefitsGrid = styled(GridWrapper)`
	margin: 0;
`;

export const Benefit = styled.div`
	border-radius: 16px;
	box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.08);
	margin-bottom: 16px;
	padding: 16px 16px 24px;

	&:last-of-type {
		margin-bottom: 0;
	}

	${minWidth('tablet')} {
		margin-bottom: 0;
		padding: 16px 32px 24px;
	}
`;

export const BenefitIcon = styled.svg`
	height: 26px;
	width: 26px;
	margin-bottom: 8px;
`;

export const BenefitHeading = styled.h5`
	color: ${palette('gray8')};
	font-size: 20px;
	${fontWeight(FontWeights.Medium)};
	margin-bottom: 8px;

	${minWidth('tablet')} {
		font-size: 22.5px;
	}
`;

export const BenefitDescription = styled.p`
	color: ${palette('gray8')};
`;
